import React from 'react'
import PropTypes from 'prop-types'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import WithMaterialUI from '../../components/WithMaterialUI'

const styles = (theme) => {
  return {
    main: {
      width: 'auto',
      display: 'block', // Fix IE 11 issue.
      marginLeft: theme.spacing.unit * 3,
      marginRight: theme.spacing.unit * 3,
      [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
        width: '400px',
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    paper: {
      alignItems: 'center',
      padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit
        * 3}px`,
      maxWidth: '600px',
      margin: 'auto',
      position: 'relative',
    },
    avatar: {
      marginTop: '30px',
      marginRight: '25px',
      backgroundColor: 'dodgerblue',
      width: '40px',
      height: '40px',
      position: 'absolute',
      top: '0%',
      right: '0%',
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing.unit,
    },
    submit: {
      marginTop: theme.spacing.unit * 3,
      color: 'white',
      fontWeight: 'bold',
      backgroundColor: 'cornflowerblue',
    },
    formLabel: {
      color: '#1e88e5',
    },
    title: {
      color: 'cornflowerblue',
    },
  }
}

@WithMaterialUI
@withStyles(styles)
class LoginPage extends React.Component {
  state = {
    username: '',
    password: '',
  }

  validateForm() {
    return this.state.username.length > 0 && this.state.password.length > 0
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    })
  }

  render() {
    const { username, password } = this.state
    const { classes } = this.props
    console.log(this.state)
    console.log(this.props)
    return (
      <main className={classes.main}>
        <br />
        <CssBaseline />
        <Paper className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <h1 className={classes.title}>Sign in</h1>
          <form className={classes.form}>
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="username">Username</InputLabel>
              <br />
              <br />
              <Input
                id="username"
                name="username"
                autoComplete="username"
                autoFocus
                value={username}
                onChange={this.handleChange}
              />
            </FormControl>
            <br />
            <br />
            <FormControl margin="normal" required fullWidth>
              <InputLabel htmlFor="password">Password</InputLabel>
              <br />
              <Input
                name="password"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={this.handleChange}
              />
            </FormControl>
            <br />
            <br />
            {/* <FormControlLabel */}
            {/* className={classes.formLabel} */}
            {/* control={<Checkbox value="remember" color="primary" />} */}
            {/* label="Remember me" */}
            {/* /> */}
            <br />
            <br />
            <Button
              disabled={!this.validateForm()}
              type="submit"
              fullWidth
              variant="contained"
              className={classes.submit}
            >
              Login
            </Button>
            <br />
            <br />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              className={classes.submit}
              disabled={true}
            >
              Register
            </Button>
          </form>
        </Paper>
      </main>
    )
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object,
}

export default LoginPage
